import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { get, isNull } from 'lodash';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import messages from 'containers/OpeningClaimPageManager/messages';
import { translate } from 'containers/services/translate';
import ClaimDeclaration from 'containers/OpeningClaimPageManager/ClaimDeclaration';
import { Dialog } from 'containers/CourtManagerAssignedClaims/styled-components';
import NavigationButtons from 'components/navigationButtons';
import currentUserStorage from 'containers/services/security/current-user-storage';
import ClaimInformation from 'containers/PreOpeningPage/ClaimInformation';
import OpposingParty from 'containers/PreOpeningPage/OpposingParty/OpposingParty';
import { PAGES } from 'routes';
import { pushTo } from 'containers/services/routes-helper';
import routesHelper from 'containers/services/routes-helper';
import { Config, Listings } from 'containers/AppContainer/typings';
import MaterialUploadDocumentsBloc from 'containers/OpeningClaimPageManager/MaterialUploadedDocument';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import CicaForm from 'containers/ConvertClaimOpeningManager/CicaForm';
import { CHOICE } from 'containers/PreOpeningPage/constants';
import { DECISION_METERIAL_CLAIM } from 'containers/OpeningClaimPageManager/constants';
import { extractOpposingParties } from 'containers/PreOpeningPage/utils';
import { resolveSagisClaim } from 'helpers/utils';
import { GLOBAL_STATUS } from 'services/constants';

export interface ConversionClaimManagerProps {
  intl: IntlShape;
  listings: Listings;
  setClaim: Function;
  storedClaimToPreopen: any;
  policyInfo: { sagis: {}; lossDate: Date };
  selectedClaim: any;
  corporealLawyers: any;
  requestSearchClaimInfo: Function;
  claimNumber: string;
  notification: any;
  requestMakeDecisionClaim: Function;
  setUploadDocument: Function;
  requestNotificationOpeningManagerMixedClaim: Function;
}

const StyledDiv = styled.div`
  height: 24px;
  text-align: left;
  font-family: Roboto;
  letter-spacing: 0;
  color: #384164;
  opacity: 1;
  font-size: 20px;
  margin-top: 50px;
  margin-bottom: 40px;
  font-weight: 100;
`;
export const ConversionClaimManager: React.FC<ConversionClaimManagerProps> = (
  props,
): JSX.Element => {
  const [claimToPreopen, setClaimToPreopen] = useState({
    claim: {},
    driver: {},
    vehicule: {},
    victims: [],
    documents: get(props.storedClaimToPreopen, 'documents', []),
    opposingParty: {
      hasMaterialDammage: null,
      vehicules: [],
    },
  });
  const [decision, setDecision] = useState(null);
  const [reason, setReason] = useState(null);
  const [otherReason, setOtherReason] = useState(null);

  const [confirmationDialog, setConfirmationDialog] = useState(false);

  const [claimValidation] = React.useState({});

  const handleChange = (claimToPreopen: any) => {
    setClaimToPreopen(claimToPreopen);
  };

  useEffect(() => {
    if (props.claimNumber) {
      props.requestSearchClaimInfo(props.claimNumber);
      props.setClaim({});
      props.setUploadDocument({});
    } else {
      routesHelper.pushTo(PAGES.MANAGER_HOME)();
    }
  }, [props.claimNumber, props.notification]);
  useEffect(() => {
    setClaimToPreopen({
      claim: get(props.storedClaimToPreopen, 'claim', {}),
      driver: get(props.storedClaimToPreopen, 'driver', {}),
      vehicule: get(props.storedClaimToPreopen, 'vehicule', {}),
      victims: get(props.storedClaimToPreopen, 'victims', []),
      documents: get(props.storedClaimToPreopen, 'documents', []),
      opposingParty: get(props.storedClaimToPreopen, 'opposingParty', {
        hasMaterialDammage: null,
        vehicules: [],
      }),
    });
  }, [props.storedClaimToPreopen, props.notification, props.claimNumber]);
  const successCallBack = () => {
    toast.success(translate(messages.convertClaimSuccessToast, props));
    props.requestNotificationOpeningManagerMixedClaim();
    get(props.notification, 'nature', null)?.toUpperCase() === 'CICA'
      ? pushTo(PAGES.MANAGER_HOME)()
      : decision === CHOICE.YES
      ? pushTo(PAGES.OPENING_CLAIM)()
      : pushTo(PAGES.MANAGER_HOME)();
  };
  const handleCloseConfirmationDialog = () => {
    setConfirmationDialog(false);
  };
  const handleNextPageClick = () => {
    setConfirmationDialog(true);
  };
  const handleValidate = () => {
    const reasonChoice = get(
      get(props.listings, 'claimConvertingRejectionReason', []).find(
        (item: Config) => item.id === Number(reason),
      ),
      'title',
      '',
    );
    const payload = {
      decision:
        decision === CHOICE.YES
          ? DECISION_METERIAL_CLAIM.ACCEPTED
          : DECISION_METERIAL_CLAIM.REJECTED,
      nature: get(props.notification, 'nature'),
      reason: reasonChoice === 'Autre' ? otherReason : reasonChoice,
      claimNumber: props.claimNumber,
      id: get(props.notification, 'id'),
      status: GLOBAL_STATUS.VALIDATED,
      treated: true,
      treatedBy: get(currentUserStorage.get(), 'username', ''),
    };
    props.requestMakeDecisionClaim(
      {
        ...payload,
      },
      successCallBack,
    );
  };

  return (
    <div>
      <StyledDiv>
        {translate({ ...messages.convertClaimTitle }, props, {
          claimNumber: props.claimNumber,
        })}
      </StyledDiv>
      <ClaimDeclaration
        listings={props.listings}
        updateFilde={handleChange}
        claimToPreopen={claimToPreopen}
        storedClaimToPreopen={props.storedClaimToPreopen}
        policyInfo={props.policyInfo}
        claimDeclarationValidation={get(
          claimValidation,
          'claimDeclaration',
          {},
        )}
        isRecapPage={false}
        isReadOnly={false}
        isManager={false}
        selectedClaim={0}
        shouldNotDisplayQuestionDriver={true}
      />
      <ClaimInformation
        isRecapPage={false}
        isReadOnly={false}
        isManager={false}
        policyInfo={props.policyInfo}
        updateFilde={handleChange}
        listings={props.listings}
        claimToPreopen={claimToPreopen}
        storedClaimToPreopen={props.storedClaimToPreopen}
        claimInformationsValidation={get(
          claimValidation,
          'claimInformations',
          {},
        )}
        stakeholders={[]}
        shouldDisplayAllClaimInfo={true}
        disableJurisdiction
      />

      {featureService.hasFeature(FEATURES.OPPOSING_PARTY) && (
        <OpposingParty
          listings={props.listings}
          setClaimToPreopen={setClaimToPreopen}
          claimToPreopen={claimToPreopen}
          opposingPartyValidation={get(claimValidation, 'opposingParty', {})}
          shouldDisplayAllClaimInfo={true}
          sagisOpposingParties={extractOpposingParties(
            get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []),
          )}
        />
      )}
      <MaterialUploadDocumentsBloc policyInfo={props.policyInfo} />
      <CicaForm
        setDecision={setDecision}
        decision={decision as any}
        reason={reason as any}
        setReason={setReason}
        listings={props.listings}
        setOtherReason={setOtherReason}
        otherReason={otherReason as any}
        nature={get(props.notification, 'nature', null)}
      />
      <NavigationButtons
        isRecap
        forwardClick={handleNextPageClick}
        onPreviousClick={routesHelper.pushTo(PAGES.MANAGER_HOME)}
        disabledMoveButton={
          isNull(decision) ||
          (decision === CHOICE.NO && isNull(reason)) ||
          (get(
            get(props.listings, 'claimConvertingRejectionReason', []).find(
              (item: Config) => item.id === Number(reason),
            ),
            'title',
            '',
          ) === 'Autre' &&
            isNull(otherReason))
        }
      />
      {confirmationDialog && (
        <Dialog
          open={confirmationDialog}
          handleClose={handleCloseConfirmationDialog}
          handleValidate={handleValidate}
          title={translate(messages.sideBarNotificationDialogTitle, props)}
          confirmTitle={translate(
            messages.convertClaimConfirmationValidationButton,
            props,
          )}
          cancelTitle={translate(
            messages.convertClaimConfirmationCancelButton,
            props,
          )}
        >
          {decision === CHOICE.YES ? (
            <div className="content">
              {translate(
                messages.convertClaimConfirmationDescriptionAccept,
                props,
              )}
            </div>
          ) : (
            <div className="content">
              {translate(
                messages.convertClaimConfirmationDescriptionReject,
                props,
                {
                  reason:
                    get(
                      get(
                        props.listings,
                        'claimConvertingRejectionReason',
                        [],
                      ).find((item: Config) => item.id === Number(reason)),
                      'title',
                      '',
                    ) === 'Autre'
                      ? otherReason
                      : get(
                          get(
                            props.listings,
                            'claimConvertingRejectionReason',
                            [],
                          ).find((item: Config) => item.id === Number(reason)),
                          'title',
                          '',
                        ),
                },
              )}
            </div>
          )}
          <div className="info-message">
            {translate(messages.convertClaimDialogInfo, props)}
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default injectIntl(ConversionClaimManager);
